// src/graphql/queries/salesQueries.js
// Sales cockpit: cold-call prospect book + tender matching

const prospectFields = `
        id
        companyName
        contactName
        contactEmail
        phone
        website
        city
        segment
        listName
        status
        notes
        crmRecordId
        teaserToken
        helloCode
        lastContactedAt
        nextFollowUpAt
        createdAt
        updatedAt
        searchProfile {
            query
            cpvCode
            nutsCodePrefix
            contractNatures
        }`;

export const getSalesProspects = () => `query GetSalesProspects($status: String, $listName: String, $search: String, $limit: Int, $offset: Int) {
    salesProspects(status: $status, listName: $listName, search: $search, limit: $limit, offset: $offset) {
        items {${prospectFields}
        }
        totalCount
    }
}`;

export const getSalesProspect = () => `query GetSalesProspect($id: String!) {
    salesProspect(id: $id) {${prospectFields}
        emails {
            id
            recipient
            subject
            status
            error
            tenderIds
            createdAt
        }
    }
}`;

export const getSalesProspectMatches = () => `query GetSalesProspectMatches($id: String!, $limit: Int) {
    salesProspectMatches(id: $id, limit: $limit) {
        id
        externalId
        title
        description
        buyerName
        url
        deadline
        publicationDate
        estimatedValue
        currency
        hasInsight
        location {
            city
            state
            nutsCode
        }
    }
}`;

export const getSalesProspectListNames = () => `query GetSalesProspectListNames {
    salesProspectListNames
}`;

export const getCrmContacts = () => `query GetCrmContacts($source: String, $industry: String, $limit: Int) {
    crmContacts(source: $source, industry: $industry, limit: $limit) {
        crmPersonId
        crmCompanyId
        companyName
        personName
        email
        phone
        city
        jobTitle
        industry
        source
        description
        alreadyImported
    }
}`;

export const getCrmContactSources = () => `query GetCrmContactSources {
    crmContactSources
}`;

const crmCompanyFields = `
    id
    name
    phone
    city
    state
    region
    address
    prio
    status
    source
    categories
    size
    employees
    domains
    description
    notes
    followUpAt
    lastCallAt
    lat
    lng
    people { id name jobTitle }`;

export const getCrmCallList = () => `query GetCrmCallList($source: String, $state: String, $prio: String, $status: String, $search: String, $followUpOnly: Boolean, $limit: Int, $offset: Int) {
    crmCallList(source: $source, state: $state, prio: $prio, status: $status, search: $search, followUpOnly: $followUpOnly, limit: $limit, offset: $offset) {
        items {${crmCompanyFields}
        }
        totalCount
    }
}`;


// Founder-meeting booking (Profil-Check / Onboarding): the cockpit reads the
// same live slots the prospect pages offer - one calendar, three doors.
export const getMeetingSlots = () => `query GetMeetingSlots($kind: String!) {
    meetingSlots(kind: $kind) {
        start
        end
    }
}`;
